import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Sparte } from '@mwe/models';
import { NgClass } from '@angular/common';
import { ProductIconComponent } from '../../product-icon/product-icon.component';
import { TranslateDirective } from '@ngx-translate/core';
import { CategoryIconSrcPipe, TranslateCategoryPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-product-radio-button-selection',
  templateUrl: './product-radio-button-selection.component.html',
  imports: [NgClass, ProductIconComponent, TranslateDirective, TranslateCategoryPipe, CategoryIconSrcPipe],
})
export class ProductRadioButtonSelectionComponent {
  @Input() categories: Sparte[];
  @Input() canShowError = false;
  @Input() errorMessage: string;
  @Output() selected = new EventEmitter<Sparte>();
  currentCategory: Sparte;

  get isInvalid(): boolean {
    return this.canShowError && !this.currentCategory;
  }

  onSelected(newCategory: Sparte) {
    this.currentCategory = newCategory;
    this.selected.emit(newCategory);
  }
}
